import ReactMarkdown from 'react-markdown'

import remarkHeadingId from 'remark-custom-heading-id'
import remarkGfm from 'remark-gfm'

import { useFile } from '../../data/tenantFiles/hooks'
import { ProgressSpinnerTemplate } from '../ProgressTemplate'

type RemoteMarkdownProps = {
  filename: string
}

export const RemoteMarkdown: React.FC<RemoteMarkdownProps> = ({ filename }) => {
  const { file } = useFile(filename)

  if (!file) return <ProgressSpinnerTemplate />

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm, remarkHeadingId]}
      children={file}
    />
  )
}
